import { FC, PropsWithChildren } from 'react';

import { useRecordPageView } from '../hooks/useRecordPageView';

export const PageViewProvider: FC<PropsWithChildren> = ({ children }) => {
  useRecordPageView();
  return children;
};
